import React from 'react';
import './CategoryFilter.css';

const CategoryFilter = ({ categories, selectedCategory, onCategoryChange }) => {
  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <div className="category-filter">
      <h3 className="category-filter-title">Categories</h3>
      <div className="category-filter-list">
        <button
          className={`category-filter-item ${!selectedCategory ? 'active' : ''}`}
          onClick={() => onCategoryChange(null)}
        >
          All
        </button>
        {categories.map((category) => (
          <button
            key={category}
            className={`category-filter-item ${selectedCategory === category ? 'active' : ''}`}
            onClick={() => onCategoryChange(category)}
          >
            {category}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;

